import { render, staticRenderFns } from "./indexBottom.vue?vue&type=template&id=ca52f4ca&scoped=true"
import script from "./indexBottom.vue?vue&type=script&lang=js"
export * from "./indexBottom.vue?vue&type=script&lang=js"
import style0 from "./indexBottom.vue?vue&type=style&index=0&id=ca52f4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52f4ca",
  null
  
)

export default component.exports